import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const getAuthToken = (state) => state.user.token

export const walkthroughsApi = createApi({
    reducerPath: 'walkthroughsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE_URL,
        prepareHeaders: (headers, { getState }) => {

            const token = getAuthToken(getState())

            if (token) headers.set(`Authorization`, `Bearer ${token}`)

            return headers
        }
    }),
    endpoints: (builder) => ({

        getwWalkthroughs: builder.query({

            query: (queryPamramString) => `/api/jobs/find?type=Walkthrough&${queryPamramString}`,
            keepUnusedDataFor: 10

        })

    })
})

export const { useGetwWalkthroughsQuery } = walkthroughsApi